<template>
  <section class="searchResults">
    <ParagraphBody
      bodySize="large"
      weight="bold"
    >
      {{ $options.noResultsFoundText }}
    </ParagraphBody>
    <ParagraphBody bodySize="large">
      {{ $options.addNewApplicationText }}
    </ParagraphBody>
    <IconButton
      class="addButton"
      :data-test-id="$testId('addApplicationButton')"
      hasOutline
      icon="add"
      iconPosition="left"
      :text="$options.addApplicationActionText"
      type="secondary"
      @click="handleAddApplication"
    />
    <LoadingOverlay
      class="overlay"
      :delayTime="20000"
      hasBlur
      isLight
      :visible="isLoading"
    />
  </section>
</template>

<script>
import * as Constants from 'client/util/Constants';
import {
  IconButton,
  LoadingOverlay,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import Util from 'client/util/Util';

const {
  ItemTypeConsts,
  ItemTypeRoutes,
} = Constants;

const addApplicationActionText = 'Add New Application';
const addNewApplicationText = 'Do you want to add a new application?';
const noResultsFoundText = 'There are no configured applications with that search term.';

export default {
  name: 'ApplicationItemListNoSearchResults',

  components: {
    IconButton,
    LoadingOverlay,
    ParagraphBody,
  },

  props: {
    isLoading: Boolean,
  },

  addApplicationActionText,
  addNewApplicationText,
  noResultsFoundText,

  methods: {
    handleAddApplication() {
      const route = this.$hasFeatureFlag(this.$featureFlags.applicationWorkflow)
        ? `${ItemTypeRoutes[ItemTypeConsts.application]}/create`
        : `${ItemTypeRoutes[ItemTypeConsts.sso]}/choose`;

      // @todo: here to call out replacing this with a vue router method
      Util.redirect(route);
    },
  },
};
</script>

<style scoped>

.addButton {
  margin-top: 20px;
}

.overlay {
  left: var(--jc-spacer-negative);
  right: var(--jc-spacer-negative);
}

.searchResults {
  margin-top: 5%;
  padding: var(--jc-size-3) var(--jc-spacer-medium);
  text-align: center;
}
</style>
